import {environment} from '@env';
import {appConfig} from '@app/app.config';
import {AppComponent} from '@app/app.component';
import {enableProdMode, provideZoneChangeDetection} from '@angular/core';
import {bootstrapApplication, provideClientHydration, withEventReplay} from '@angular/platform-browser';

if (environment.production) {
  enableProdMode();
}

bootstrapApplication(AppComponent, {
  ...appConfig,
  providers: [
    provideZoneChangeDetection(),
    ...appConfig.providers,
    provideClientHydration(withEventReplay())
  ]
})
  .catch(e => console.error(e));

